/* eslint-disable camelcase */
import { GAME_IDS, TIMINGS_STORAGE_ID } from '../config'

export const TIMINGS_CHANGED = 'TIMINGS_CHANGED'

type Callback = (...args: unknown[]) => void

export class Timings {
	eventHandlers: Record<string, Callback[]> = {}

	// This data will get stored/loaded from localStorage
	gameid: string
	timings: number[] = []
	words: string[] = []

	constructor(gameId: string) {
		this.eventHandlers = {}
		this.load(gameId)
	}

	load(gameid: string): void {
		if (this.gameid === gameid) return
		this.gameid = gameid

		// Load data from localStorage
		const str = localStorage.getItem(TIMINGS_STORAGE_ID(this.gameid)) || '{}'
		const data = JSON.parse(str)
		Object.keys(data).forEach(key => (this[key] = data[key]))
		this.emit(TIMINGS_CHANGED)
	}

	save(): void {
		const simpleObj = JSON.parse(JSON.stringify(this))
		delete simpleObj.eventHandlers
		localStorage.setItem(TIMINGS_STORAGE_ID(this.gameid), JSON.stringify(simpleObj))
	}

	reset(): void {
		this.timings = []
		this.words = []
		this.save()
	}

	setWordTiming(wordindex: number, word: string, time: number): void {
		if (!this.timings[wordindex]) {
			this.timings[wordindex] = time
			this.words[wordindex] = word
			this.save()
			this.emit(TIMINGS_CHANGED)
		}
	}

	getWordTimings(): number[] {
		return this.timings
	}

	// -----------------------------------------------------------------------------------------------

	on(event: string, callback: Callback): void {
		this.eventHandlers[event] = this.eventHandlers[event] || []
		this.eventHandlers[event].push(callback)
	}

	off(event: string, callback: Callback): void {
		if (this.eventHandlers[event]) {
			this.eventHandlers[event] = this.eventHandlers[event].filter(
				handler => handler !== callback
			)
		}
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	emit(event: string, ...args): void {
		if (this.eventHandlers[event]) {
			this.eventHandlers[event].forEach(handler => handler(...args))
		}
	}
}

export const daily5Timings = new Timings(GAME_IDS.DAILY5)
export const daily5ArchiveTimings = new Timings(GAME_IDS.DAILY5_ARCHIVE)
export default Timings
